import React from 'react';
import SelectedContactDisplay from 'src/components/SelectedContactDisplay/SelectedContactDisplay';
import {
  ContactPickerOrchestrator,
  useContactPickerOrchestrator,
} from './CustomHooks/useContactPickerOrchestrator';
import { CanonicalContact } from './helpers/contactShape';
import ContactPickerPanel from './components/ContactPickerPanel';
import LegacyContactPickerPanel from './components/LegacyContactPickerPanel';
import './ContactPicker.scss';

interface ContactPickerProps {
  serviceRequest: any;
  setFormData: any;
  from: any;
  isLegacyTable?: boolean;
  onSelectedContactChange?: (contact: CanonicalContact | null) => void;
}

export const ContactPicker = ({
  serviceRequest,
  setFormData,
  from,
  isLegacyTable,
  onSelectedContactChange,
}: ContactPickerProps) => {
  const orchestrator: ContactPickerOrchestrator = useContactPickerOrchestrator({
    serviceRequest,
    from,
    setFormData,
    onSelectedContactChange,
  });

  const subtitleVariant: 'role-only' | 'role-and-services' =
    from === 'dashboard' ? 'role-and-services' : 'role-only';

  return (
    <div className="contact-picker">
      <SelectedContactDisplay
        contact={orchestrator.selectedContact}
        subtitleVariant={subtitleVariant}
        onClear={orchestrator.onClearSelectedContact}
      />

      {isLegacyTable ? (
        <LegacyContactPickerPanel
          isLoading={orchestrator.isLoading}
          propertyContacts={orchestrator.propertyContacts}
          allContacts={orchestrator.allContacts}
          subtitleVariant={subtitleVariant}
          onSelectContact={orchestrator.onSelectContact}
        />
      ) : (
        <ContactPickerPanel
          isLoading={orchestrator.isLoading}
          groupedResults={orchestrator.groupedResults}
          availableCategories={orchestrator.availableCategories}
          availableRoles={orchestrator.availableRoles}
          searchTerm={orchestrator.searchTerm}
          selectedRoles={orchestrator.selectedRoles}
          selectedCategories={orchestrator.selectedCategories}
          subtitleVariant={subtitleVariant}
          onChangeSearchTerm={orchestrator.onChangeSearchTerm}
          onChangeSelectedRoles={orchestrator.onChangeSelectedRoles}
          onChangeSelectedCategories={
            orchestrator.onChangeSelectedCategories
          }
          onSelectContact={orchestrator.onSelectContact}
        />
      )}
    </div>
  );
};

export default ContactPicker;
